import { ServerErrorLog } from "../../../../Common/CandyApiClient/Types/ErrorLog/ServerErrorLog";
import { IErrorLogTaskResult } from "../Core/ErrorManager/Utils/Models";

export function getFakeErrorLogForDraft(draftId: string): undefined | ServerErrorLog | IErrorLogTaskResult {
    if (process.env.NODE_ENV === "development") {
        const fakeErrorLogString = sessionStorage.getItem("FakeErrorLog." + draftId);
        if (fakeErrorLogString != undefined) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return JSON.parse(fakeErrorLogString);
        }
    }
    return undefined;
}

export function setFakeErrorLogForDraft(draftId: string, errorLog: ServerErrorLog | IErrorLogTaskResult): void {
    if (process.env.NODE_ENV === "development") {
        sessionStorage.setItem("FakeErrorLog." + draftId, JSON.stringify(errorLog));
    } else {
        throw new Error("Cannot set fake error log in production build");
    }
}
